module.exports = __webpack_public_path__ + "1dd30915.png";